module.exports = __webpack_public_path__ + "img/story16.2.jpg";